// import { SEASONAL_SETS } from '../content/constants';

export default {
  opened: false,

  currentSeason: 'Closed',

  dateRange: { start: '2019-09-24', end: '2019-10-31' },

  availableSets: [
  ],

  pinnedSets: {
  },

  availableSpells: [
  ],

  availableQuests: [
  ],

  featuredSet: 'fall2018AlterEgoSet',
};
